import template from './assign-user-to-team.html';
import controller from './assign-user-to-team.controller';


const AssignUserToTeamComponent = {
  template,
  controller,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
};

export default AssignUserToTeamComponent;



// WEBPACK FOOTER //
// ./components/popups/user-popup/assign-user-to-team/assign-user-to-team.component.js